import styled from 'styled-components'
import { Checkbox as CheckboxAnt } from 'antd'

import images from 'src/config/images'

export const ModalMask = {
  backgroundColor: '#f0f2f5',
  backgroundImage: `url(${images.login.bg})`,
  backgroundPosition: 'center 110px',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100%',
  overflow: 'auto'
}

export const Checkbox = styled(CheckboxAnt)`
  margin: 1rem 0.5rem 0 0.5rem;
`
